import { render } from "./KeysVault.vue?vue&type=template&id=e5547f9e&scoped=true"
import script from "./KeysVault.vue?vue&type=script&lang=js"
export * from "./KeysVault.vue?vue&type=script&lang=js"

import "./KeysVault.vue?vue&type=style&index=0&id=e5547f9e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5547f9e"]])

export default __exports__